var _path, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuestionnaire(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1853 3.33398C16.0024 3.33398 16.6668 3.99843 16.6668 4.81547V15.1858C16.6668 16.0029 16.0024 16.6673 15.1853 16.6673H4.81498C3.99794 16.6673 3.3335 16.0029 3.3335 15.1858V4.81547C3.3335 3.99843 3.99794 3.33398 4.81498 3.33398H15.1853ZM4.81498 4.81547V15.1858H15.1868L15.1853 4.81547H4.81498ZM7.77666 6.29768H6.29666V7.77916H7.77666V6.29768ZM13.7041 6.29768H9.25962V7.77916H13.7041V6.29768ZM7.77666 9.26064H6.29666V10.7421H7.77666V9.26064ZM13.7041 9.26064H9.25962V10.7421H13.7041V9.26064ZM7.77666 12.2236H6.29666V13.7051H7.77666V12.2236ZM13.7041 12.2236H9.25962V13.7051H13.7041V12.2236Z",
    fill: "#828282"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 4.5,
    r: 2,
    fill: "#EB5757"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionnaire);
export default __webpack_public_path__ + "static/media/questionnaire.01b88dc76189cb048bbff7a8f8e7d8a0.svg";
export { ForwardRef as ReactComponent };